<template>
    <div class="discuss-page">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <!-- v-if="shareData.cansave != 1" -->
        <div class="comment-fate-topbar discuss-fate-topbar">
            <!-- 1、顶部菜单栏 -->
            <div class="comment-title-bar dsp-flex">
                <div class="comment-title-side">
                    <span v-if="fromEmbedded" class="discuss-title-back" @click="clickClose">
                        <i class="iconfont icon-guanbi"></i>
                    </span>
                    <span v-else class="comment-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                    <span class="comment-title-report" v-if="shareData.cansave == 1 || (userData && userData.info && userData.info.uid != lunpanData.uid)" @click="clickReport">测算</span>
                </div>
                <div class="comment-title-mid" @click="toggleName">
                    <span v-if="hideName">匿名</span>
                    <span v-else>{{detailInfo.f_name}}</span>
                </div> 
                <div class="comment-title-side" v-if="fromEmbedded" @click="clickShare">
                    <span class="comment-title-save">分享</span>
                </div>
                <div class="comment-title-side" v-if="(shareData.cansave == 1 || (userData && userData.info && userData.info.uid != lunpanData.uid && hotLunpanData)) && lunpanSavedList.length == 0" @click="clickSave">
                    <span class="comment-title-save">保存</span>
                </div>
            </div>
            <!-- 2、迷你:命盘+运盘组件 -->
            <mini-fate-fortune-panel
                v-bind:fromPage="pageName">
            </mini-fate-fortune-panel>
        </div>

        <!-- 聊天记录列表 -->
        <!-- v-if="shareData.cansave != 1" -->
        <discuss-history-list></discuss-history-list>

        <!-- 聊天输入框 -->
        <!-- && shareData.cansave != 1 -->
        <discuss-bottom-bar v-if="hasLogined && lunpanData.isEnd != 1"></discuss-bottom-bar>

        <!-- 提示分享蒙层 -->
        <div class="layout-overlay" v-if="isNewLunPan && showNewSharePop && !fromEmbedded && CONFIG.platform != 'web'">
            <div class="discuss-share-note">
                <p v-if="CONFIG.platform == 'wechat'">转发到微信群<br />邀请大家进入论盘</p>
                <p v-if="CONFIG.platform == 'qq'">转发到QQ群<br />邀请大家进入论盘</p>
                <div class="discuss-share-btn" @click="clickKnow">知道了</div>
            </div>
        </div>

        <!-- 提示打开浮窗弹框 -->
        <!-- shareData.cansave != 1 &&  -->
        <div id="floatPopOverlay" class="layout-overlay layout-overlay-blank" v-if="showDiscussFloatPop && !fromEmbedded" @click="clickDiscussFloatOverLay"></div>
        <discuss-float-pop v-if="showDiscussFloatPop && !fromEmbedded"></discuss-float-pop>
                
        <!-- 录音上滑操作提示 -->
        <div class="discuss-voice-operate-tips" v-if="showVoiceOperateTips">
            <div class="discuss-vot-top dsp-flex">
                <div class="discuss-vott-left">
                    <i class="iconfont icon-micro"></i>
                </div>
            </div>
            <div class="discuss-vot-bottom dsp-flex">
                <div class="discuss-votb-left"><i class="iconfont icon-back"></i></div>
                <div class="discuss-votb-mid">上滑取消或转文字</div>
                <div class="discuss-votb-right"><i class="iconfont icon-wen"></i></div>
            </div>
        </div>

        <!-- 录音取消or转文字操作框 -->
        <div class="discuss-voice-operate-panel" v-if="showVoiceOperatePanel">
            <div class="discuss-vop-content">
                <div class="discuss-vop-icon"><i class="iconfont icon-micro"></i></div>
                <div class="discuss-vop-note">松开手指，取消发送</div>
            </div>
            <div class="discuss-vop-bottom dsp-flex">
                <div class="discuss-vop-item discuss-vop-item-left">
                    <button class="discuss-vop-button discuss-vop-button-cancel"><i class="iconfont icon-back"></i><br>取消</button>
                </div>
                <div class="discuss-vop-item discuss-vop-item-right">
                    <button class="discuss-vop-button discuss-vop-button-wen"><i class="iconfont icon-wen"></i><br>转文字</button>
                </div>
            </div>
        </div>

        <!-- 弹框:修改论盘名称 -->
        <van-dialog v-model="showDiscussEditPop" v-bind:title="'修改论盘名称'" v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" placeholder="请输入论盘名称" v-model="inputLunPanName" maxlength="25" autofocus />
            </div>
        </van-dialog>

        <!-- 弹框:确认是否撤回消息 -->
        <vant-discuss-recall-pop
            v-bind:showPop="showDiscussRecallPop"
            v-bind:overlayFunc="clickDiscussRecallOverlay"
            v-bind:confirmFunc="clickDiscussRecallConfirm"
            v-bind:cancelFunc="clickDiscussRecallCancel">
        </vant-discuss-recall-pop>
        
        <!-- 论盘操作气泡用:空的遮罩层 -->
        <!-- <div v-if="showDiscussBOverlay" class="layout-overlay layout-overlay-blank" @click="clickBlankOverlay"></div> -->
        <discuss-note-bubble></discuss-note-bubble>

        <!-- 弹框:提示下载 -->
        <discuss-download-pop></discuss-download-pop>

        <!-- 弹框:保存论盘 -->
        <vant-discuss-save-pop></vant-discuss-save-pop>

        <!-- 弹框:保存八字进入测算 -->
        <vant-discuss-report-pop></vant-discuss-report-pop>

        <!-- 论盘操作:点击头像弹框遮罩层 -->
        <div v-if="showDiscussAOverlay" class="layout-overlay" @click="clickAvatarOverlay"></div>
        
        <!-- 子页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import DiscussHistoryList from '../../layouts/discuss/DiscussHistoryList.vue'
import DiscussBottomBar from '../../layouts/discuss/DiscussBottomBar.vue'
import DiscussFloatPop from '../../layouts/discuss/DiscussFloatPop.vue'
import DiscussNoteBubble from '../../components/discuss/DiscussNoteBubble.vue'
import VantDiscussRecallPop from '../../layouts/vant/VantDiscussRecallPop.vue'
import DiscussDownloadPop from '../../layouts/discuss/DiscussDownloadPop.vue'
import { DISCUSS_DOM } from '../../modules/dom'
import { MIX, SCHEME, UA } from '../../modules/utils'
import { SHARE } from '../../modules/share'
import { WS } from '../../modules/websocket'
import { DATA } from '../../modules/data'
import { CONFIG } from '../../modules/config'
import VantDiscussSavePop from '../../layouts/vant/VantDiscussSavePop.vue'
import VantDiscussReportPop from '../../layouts/vant/VantDiscussReportPop.vue'
export default {
    name: 'Discuss',
    components: {MiniFateFortunePanel, DiscussHistoryList, DiscussBottomBar, DiscussFloatPop, DiscussNoteBubble, VantDiscussRecallPop, DiscussDownloadPop, VantDiscussSavePop, VantDiscussReportPop},
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        detailInfo() {
            return this.$store.state.discuss.detailInfo;
        },
        isNewLunPan() {
            return this.$store.state.discuss.isNewLunPan;
        },
        hotLunpanData() {
            return this.$store.state.discuss.hotLunpanData;
        },
        hasLogined() {
            return this.$store.state.discuss.hasLogined;
        },
        hideName() {
            return this.$store.state.discuss.hideName;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanSavedList() {
            return this.$store.state.discuss.lunpanSavedList;
        },
        shareData() {
            return this.$store.state.othershare.shareData;
        },
        showDiscussEditPop: {
            get() {
                return this.$store.state.discuss.showDiscussEditPop;
            },
            set(value) {
                this.$store.state.discuss.showDiscussEditPop = value;
            }
        },
        showDiscussRecallPop() {
            return this.$store.state.discuss.showDiscussRecallPop;
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            pageName: 'Discuss',
            showVoiceOperateTips: false,
            showVoiceOperatePanel: false,
            inputLunPanName: '',
            showDiscussFloatPop: false,
            showNewSharePop: true,
            showDiscussBOverlay: false,
            showDiscussAOverlay: false
        }
    },
    mounted: function() {
        setTimeout(() => {
            var curPath = this.$router.history.current.path;
            var curParams = this.$router.history.current.params;
            console.log('Discuss------', curPath, curParams, this.lunpanData.id);
            if(curPath.indexOf('share') == -1 && !this.lunpanData.id) {
                let fromPage = curParams.from ? curParams.from : 'discussmain';
                this.$router.replace('/'+fromPage);
                return;
            }
            var tempTime = curPath.indexOf('share') != -1 ? 1000 : 20;
            // 获取数据
            setTimeout(() => {
                this.$store.dispatch('discuss/initLunPanRoomConfig', {
                    id: this.lunpanData.rid
                });
            }, tempTime);
            DISCUSS_DOM.updateDiscussPageStyle();
            DISCUSS_DOM.updateDiscussFormStyle();
            this.checkDiscussStatus();
            MIX.trackPageViewed('LunpanChatPage');
        }, 20);

        setTimeout(() => {
            this.inputLunPanName = this.lunpanData.title;
        }, 1000);

        window.onresize = function() {
            setTimeout(() => {
                DISCUSS_DOM.updateDiscussPageStyle();
            }, 20);
        }
        this.$bus.on('showDiscussBlankOverlay', this.showBlankOverlay);
        this.$bus.on('hideDiscussBlankOverlay', this.hideBlankOverlay);
        this.$bus.on('showDiscussAvatarOverlay', this.showAvatarOverlay);
        this.$bus.on('hideDiscussAvatarOverlay', this.hideAvatarOverlay);
    },
    created: function() {
        var curPath = this.$router.history.current.path;
        if(curPath.indexOf('/embedded/discuss') == -1 && curPath.indexOf('/share/discuss') == -1 && curPath.indexOf('/discussmain') == -1  && curPath.indexOf('discusssecond') == -1 && curPath.indexOf('/collate') == -1 && !this.detailInfo.id) {
            this.$router.replace('/record');
            return;
        }
        let lunpanData = this.$store.state.discuss.lunpanData;
        if(curPath.indexOf('share') == -1 && curPath.indexOf('discussmain') != -1 && (!lunpanData || !lunpanData.id)) {
            this.$router.replace('/discussmain');
        }
        if(curPath.indexOf('share') != -1 && curPath.indexOf('discussmain') != -1) {
            this.$store.state.discuss.hotLunpanData = true;
        }
    },
    destroyed() {
        this.$bus.off('showDiscussBlankOverlay', this.showBlankOverlay);
        this.$bus.off('hideDiscussBlankOverlay', this.hideBlankOverlay);
        this.$bus.off('showDiscussAvatarOverlay', this.showAvatarOverlay);
        this.$bus.off('hideDiscussAvatarOverlay', this.hideAvatarOverlay);
    },
    methods: {
        checkDiscussStatus() {
            // 在非微信端不显示
            // if(!UA.isWeChat()) {
            //     return;
            // }
            // function handler(event) {  event.preventDefault();}

            var me = this;
            if(!this.isNewLunPan || (this.isNewLunPan && !this.showNewSharePop)) {
                this.showDiscussFloatPop = true;
                setTimeout(() => {
                    // 绑定事件
                    // document.addEventListener('touchmove', handler, false);
                    me.bindOverlayEvent();
                }, 100);
                // 定时隐藏
                setTimeout(() => {
                    me.showDiscussFloatPop = false;
                    setTimeout(() => {
                        me.unbindOverlayEvent();
                    }, 20);
                }, 5000);
            }

            // 解绑事件
            // function handler(event) {  event.preventDefault();}
            // document.removeEventListener('touchmove', handler, false);
        },
        bindOverlayEvent() {
            var me = this,
                floatDiv = document.getElementById('floatPopOverlay');
            if(floatDiv == null) { return; }
            floatDiv.addEventListener('touchstart', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.addEventListener('touchmove', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.addEventListener('touchend', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
        },
        unbindOverlayEvent() {
            var me = this,
                floatDiv = document.getElementById('floatPopOverlay');
            if(floatDiv == null) { return; }
            floatDiv.removeEventListener('touchstart', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.removeEventListener('touchmove', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
            floatDiv.removeEventListener('touchend', function() {
                me.showDiscussFloatPop = false;
                me.unbindOverlayEvent();
            });
        },
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('embedded/resetData');
        },
        clickBack() {
            var me = this,
                curPath = this.$router.history.current.path,
                params = this.$router.history.current.params;
            // 从分享页面来的 && 未保存为自己的:返回到列表页
            if(curPath.indexOf('share/discuss') > 0) {
                // 主动断掉ws
                WS.closeWebSocket();
                // 重置数据:
                this.$store.dispatch("discuss/resetLunPanData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.dispatch('detail/resetData');
                // 重置分享数据
                this.$store.dispatch('share/resetData');
                this.$store.dispatch('othershare/resetData');

                if(curPath.indexOf('discussmain') > 0) {
                    this.$router.replace('/discussmain');
                }else {
                    this.$router.replace('/record');
                }
                return;
            }

            // 从精进论盘而来
            if(curPath.indexOf('discussmain') > 0) {
                // 主动断掉ws
                WS.closeWebSocket();
                // 重置数据:
                this.$store.dispatch("discuss/resetLunPanData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.dispatch('detail/resetData');
                this.$router.replace('/discussmain');
                return;
            }

            // 从精进论盘而来
            if(curPath.indexOf('discusssecond') > 0) {
                // 主动断掉ws
                WS.closeWebSocket();
                // 重置数据:
                this.$store.dispatch("discuss/resetLunPanData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.dispatch('detail/resetData');
                this.$router.replace('/discusssecond');
                return;
            }

            // 从首页而来
            if(curPath.indexOf('collate') > 0) {
                // 主动断掉ws
                WS.closeWebSocket();
                // 重置数据:
                this.$store.dispatch("discuss/resetLunPanData");
                this.$store.dispatch("minifatefortune/resetMiniData");
                this.$store.dispatch('detail/resetData');
                this.$router.replace('/collate');
                return;
            }

            // 主动断掉ws
            WS.closeWebSocket();
            // 重置数据:
            this.$store.dispatch("discuss/resetLunPanData");
            this.$store.dispatch("minifatefortune/resetMiniData");

            // 跳转到论盘列表页面:::如果没有拉取列表的话，重置列表
            if(!this.gotLunPanList) {
                this.$store.dispatch('discuss/initLunPanList', this.detailInfo)
            }
            setTimeout(() => {
                me.$router.replace('/discusslist/' + this.detailInfo.id);
                if(!this.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 100);
        },
        clickReport() {
            let me = this,
                curPath = this.$router.history.current.path;
            let lunpanSavedList = this.$store.state.discuss.lunpanSavedList;
            let fromPath = curPath.split('/')[2];
                fromPath = curPath.indexOf('share') != -1 ? 'discussshare-'+curPath.split('/')[3]+'-'+curPath.split('/')[4] : fromPath;
            MIX.trackButtonClicked('lunpan_chat_ai');
            console.log('clickReport-----', fromPath, lunpanSavedList, this.hotLunpanData)
            if(lunpanSavedList && lunpanSavedList.length > 0) {
                let data = lunpanSavedList[0];
                if(!data) { return; }
                this.$store.dispatch('discuss/goDiscussToReport', {
                    data: data,
                    cb: function() {
                        me.$router.replace('/report/'+fromPath+'/'+data.id);
                    }
                });
                return;
            }
            if(this.hotLunpanData) {
                this.$store.dispatch('discuss/initDiscussReportPop');
                return;
            }
        },
        toggleName() {
            this.$store.state.discuss.hideName = !this.$store.state.discuss.hideName;
            var me = this;
            setTimeout(() => {
                // 设置微信JSSDK分享
                if(!this.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 100);
        },
        clickShare() {
            MIX.trackButtonClicked('lunpan_chat_share');
            var lunpanTitle = DATA.getLunPanShareTextByData('wechat', this.lunpanData.title, this.detailInfo);
            var shareId = this.hideName ? this.lunpanData.shareCode.nmlpshare : this.lunpanData.shareCode.smlpshare;
            SCHEME.configLunPanShare(lunpanTitle, shareId);
        },
        clickSave() {
            var shareData = this.$store.state.othershare.shareData,
                detailData = this.$store.state.othershare.curDiscussDetailData;
            let userVip = this.$store.state.userData.vip;
            // console.error('clickSave-----', shareData, detailData, userVip);
            MIX.trackButtonClicked('lunpan_chat_save');
            if(userVip <= 10) {
                this.$store.dispatch('user/showMyVipPop', {vip: 30, frompage: 'lunpan_save'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }
            
            let lunpanSavedList = this.$store.state.discuss.lunpanSavedList;
            if(lunpanSavedList && lunpanSavedList.length > 0) {
                return;
            }
            // 世界论盘列表保存论盘
            if(this.hotLunpanData) {
                this.$store.dispatch('discuss/initDiscussSavePop');
                return;
            }
            switch(shareData.type) {
                case 1:
                    this.$store.dispatch('othershare/triggerSaveDiscussToHave')
                    break;
                case 3:
                    this.$store.dispatch('othershare/triggerDiscussSelect');
                    break;
                case 4:
                    this.$store.dispatch('othershare/triggerDiscussChange');
                    break;
                default:
                    break;
            }
        },
        clickKnow() {
            // 隐藏分享提示
            this.showNewSharePop = false;
            this.checkDiscussStatus();
        },
        /**
         * 初始化声音操作面板dom
         */
        initVoiceOperateDom() {
            var bgDiv = document.getElementsByClassName('discuss-voice-operate-panel')[0];
            if(bgDiv) {
                bgDiv.style.width = innerWidth + 'px';
                bgDiv.style.height = innerHeight + 'px';
                bgDiv.style.overflow = 'hidden';
            }
        },
        beforeClose(action, done) {
            // window.scrollTo(0, 0);
            var me = this;
            if (action === 'confirm') {
                if(this.inputLunPanName != ''){
                    // 名称不为空
                    if(this.inputLunPanName == this.lunpanData.title){
                        this.$toast("名称未改变");
                        done();
                        return;
                    }
                    this.$store.dispatch('discuss/editLunPanData', {
                        id: this.lunpanData.id,
                        f_title: this.inputLunPanName,
                        cb: function(){
                            me.lunpanData.title = me.inputLunPanName;
                            me.$toast("修改论盘名称成功");
                            setTimeout(() => {
                                window.scrollTo(0, 0);
                                SHARE.initConfigShare();
                            }, 20);
                        }
                    })
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },
        clickDiscussFloatOverLay() {
            this.showDiscussFloatPop = false;
            this.unbindOverlayEvent();
        },
        clickDiscussRecallOverlay() {
            this.$store.state.discuss.showDiscussRecallPop = false;
        },
        clickDiscussRecallConfirm() {
            this.$store.state.discuss.showDiscussRecallPop = false;
        },
        clickDiscussRecallCancel() {
            this.$store.state.discuss.showDiscussRecallPop = false;
        },
        showBlankOverlay() {
            this.showDiscussBOverlay = true;
        },
        hideBlankOverlay() {
            this.showDiscussBOverlay = false;
        },
        clickBlankOverlay() {
            this.showDiscussBOverlay = false;
            this.$bus.emit('hideDiscussBubble');
        },
        showAvatarOverlay() {
            this.showDiscussAOverlay = true;
        },
        hideAvatarOverlay() {
            this.showDiscussAOverlay = false;
        },
        clickAvatarOverlay() {
            this.showDiscussAOverlay = false;
            this.$bus.emit('hideDiscussAvatarPop');
        }
    }
}
</script>